import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ButtonGroup,
  Text,
} from '@chakra-ui/react';
import { SyncWithMasterContextTarget } from '../../syncWithMasterContextPlan';
import { useRef } from 'react';

type SyncWithMasterContextModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  target: SyncWithMasterContextTarget;
  isLoading: boolean;
};

export const SyncWithMasterContextModal = ({
  isOpen,
  onClose,
  onConfirm,
  target,
  isLoading,
}: SyncWithMasterContextModalProps) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      size='lg'
    >
      <AlertDialogOverlay>
        <AlertDialogContent data-testid='sync-master-context-modal'>
          <AlertDialogHeader>Sync with master Context ID</AlertDialogHeader>
          <AlertDialogBody>
            <Text>
              This will replace all SitecoreAI resources on this Context ID with
              the latest state from the{' '}
              <strong>{target.environmentLabel}</strong> master Context ID for
              environment <strong>{target.tenantName}</strong>.
            </Text>
            <Text mt={3}>
              Non-SitecoreAI resources will not be affected. Are you sure you
              want to continue?
            </Text>
          </AlertDialogBody>
          <AlertDialogFooter>
            <ButtonGroup>
              <Button
                ref={cancelRef}
                variant='ghost'
                onClick={onClose}
                isDisabled={isLoading}
                data-testid='sync-master-context-modal-cancel'
              >
                Cancel
              </Button>
              <Button
                colorScheme='primary'
                onClick={onConfirm}
                isLoading={isLoading}
                data-testid='sync-master-context-modal-confirm'
              >
                Sync
              </Button>
            </ButtonGroup>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
